/* eslint-disable no-empty */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';




// Read (GET)
export const fetchData = createAsyncThunk('get data', async (productId) => {
  const response = await $axios.get(`/reviews/${productId}`);
  return response.data;
});



// Update (PUT or PATCH)
export const updateData = createAsyncThunk('update data', async ({ id, updatedData }) => {
  const response = await $axios.put(`/reviews/specific/${id}`, updatedData);
  return response.data;
});

// Delete (DELETE)
export const deleteData = createAsyncThunk('delete data', async (id) => {
  await $axios.delete(`/reviews/${id}`);
  return id;
});



export const resetDataReviewSlice = createAsyncThunk('reset data', async () => {
  return 'reset data';
});

// Slice
const reviewSlice = createSlice({
  name: 'reviewSlice',
  initialState: {
    data: [],
    newReview: null,
    newReviewError: false,
    singleReview: null,
    singleReviewError: false,
    updatedReview: null,
    updatedReviewError: false,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Fetch Data
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder.addCase(resetDataReviewSlice.fulfilled, (state, action) => {
      state.data = [];
      state.newReview = null;
      state.newReviewError = false;
      state.singleReview = null;
      state.singleReviewError = false;
      state.updatedReview = null;
      state.updatedReviewError = false;
      state.loading = false;
      state.error = null;
    });

    // Fetch Single Data
    // builder
    //   .addCase(fetchSingleData.pending, (state) => {
    //     state.singleReviewError = false;
    //     state.loading = true;
    //     state.singleReview = null;
    //   })
    //   .addCase(fetchSingleData.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.singleReview = action.payload.data;
    //   })
    //   .addCase(fetchSingleData.rejected, (state, action) => {
    //     state.loading = false;
    //     state.singleReview = null;
    //     state.singleReviewError = action.error;
    //   });

    // Create Data
    // builder
    // .addCase(createData.pending, (state, action) => {
    //   state.newReviewError = false;
    //   state.newReview  = null;
    // })
    // .addCase(createData.fulfilled, (state, action) => {
    //   state.newReview  = action.payload;
    // })
    // .addCase(createData.rejected, (state, action) => {
    //   state.newReview = null;
    //   state.newReviewError = true;
    // });

    // Update Data
    builder
    .addCase(updateData.pending, (state) => {
      state.updatedReviewError = false;
      state.loading = true;
      state.updatedReview = null;
    })
    .addCase(updateData.fulfilled, (state, action) => {
      state.loading = false;
      state.updatedReview = action.payload.data;
    })
    .addCase(updateData.rejected, (state, action) => {
      state.loading = false;
      state.updatedReview = null;
      state.updatedReviewError = action.error;
    });

    // Delete Data
    builder.addCase(deleteData.fulfilled, (state, action) => {
      if (Array.isArray(state.data)) {
    state.data = state.data.filter(item => item._id !== action.payload);
  }
    });
  },
});

export default reviewSlice.reducer;
